module.exports = __webpack_public_path__ + "assets/img/img6-449f8a28.png";